import { Dialog } from "primereact/dialog"
import { Button } from "primereact/button"
import styles from "../../../styles/Participant-Employment.module.css"

export const isFormFieldInvalid = (name, formik) =>
  !!(formik?.touched[name] && formik?.errors[name])

export const getFormErrorMessage = (name, formik) => {
  return isFormFieldInvalid(name, formik) ? (
    <small className="p-error">{formik?.errors[name]}</small>
  ) : (
    <small className="p-error">&nbsp;</small>
  )
}

export const checkErrorValidation = (error) => {
  return error?.props?.children?.length > 1
}

export const deleteConfirmationModal = (value, setValue, callback, detail) => {
  const footer = () => {
    return (
      <div className={styles.buttons}>
        <Button
          className={styles.cancel_button}
          label="No"
          onClick={() => setValue(false)}
          autoFocus
        />
        <Button
          className={styles.button}
          label="Yes"
          onClick={() => {
            callback(value)
            setValue(false)
          }}
        />
      </div>
    )
  }
  return (
    <Dialog
      header={"Delete confirmation"}
      visible={!!value}
      onHide={() => setValue(null)}
      style={{ width: "50vw" }}
      modal={false}
      footer={footer}
    >
      <p>{`Are you sure you want to delete the ${detail}?`}</p>
    </Dialog>
  )
}

export const existsErrors = (errors) => {
  return Object.keys(errors).length === 0
}
